// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__WPEG2","container":"app_container__1nkhX"};